"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitPhoneNumber = submitPhoneNumber;
exports.submitOtpAndPhoneNumber = submitOtpAndPhoneNumber;
exports.submitUserDetails = submitUserDetails;
const fetchWrapper_1 = require("./fetchWrapper");
const BaseUrl = 'https://c6uimajtrk.execute-api.us-east-1.amazonaws.com';
async function submitPhoneNumber(phone) {
    return (0, fetchWrapper_1.fetchWrapper)(BaseUrl, {
        method: 'POST',
        body: {
            phone: phone
        },
    });
}
async function submitOtpAndPhoneNumber(phone, otp) {
    return (0, fetchWrapper_1.fetchWrapper)(`${BaseUrl}/verify`, {
        method: 'POST',
        body: {
            phone: phone,
            otp: otp
        },
    });
}
async function submitUserDetails(details) {
    return (0, fetchWrapper_1.fetchWrapper)(BaseUrl, {
        method: 'POST',
        body: details,
    });
}
